import { InputAdornment, TextField, Typography } from "@mui/material";
import * as React from "react";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { Base } from "ui/Scripts/source/framework/base";
import { ITaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { FormFieldMargin } from "./TaskDynamicForm.styles";
import { DisabledInputClickEnabler } from "./DisabledInputClickEnabler";
import { getFormFieldTitleColor, getFormFieldTitle } from "./TaskDynamicFormFieldUtils";

// interface IIntegerMaskInputProps {
//     onChange: (event: { target: { name: string; value: string } }) => void;
//     name: string;
//     min?: number;
//     max?: number;
// }

// const IntegerMaskInput = React.forwardRef<HTMLInputElement, IIntegerMaskInputProps>(
//     function TextMaskCustom(props, ref) {
//         console.log("IntegerMaskInput", props.min, props.max);
//         const { onChange, ...other } = props;
//         return (
//             <IMaskInput
//                 {...other}
//                 min={props.min ?? 0}
//                 max={props.max ?? 2147483647}
//                 mask={Number}
//                 inputRef={ref}
//                 onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
//                 scale={0}
//                 overwrite
//             />
//         );
//     },
// );

// IntegerMaskInput.displayName = "IntegerMaskInput";

export interface ITaskDynamicFormIntegerProp {
    isReadOnly: boolean;
    colIsReadOnly: boolean;
    showFieldName: boolean;
    showFieldNameColor: string;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormInteger extends React.Component<ITaskDynamicFormIntegerProp, {}> {
    handleChange = (event) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const target = event.target;
        const strValue: string = Base.filterIntegerStr(target.value, typeCol.minimum, typeCol.maximum);
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (!typeCol.required && Base.isNullOrEmpty(strValue)) {
            newValue.valueStr = "";
            newValue.valueNbr = null;
            this.props.onChange(newValue);
            return;
        }
        newValue.valueStr = strValue;
        newValue.valueNbr = !Base.isNullOrEmpty(strValue) ? Base.strToInteger(strValue, typeCol.minimum, typeCol.maximum) : 0;
        props.onChange(newValue);
    };

    handleBlur = (event) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const target = event.target;
        const strValue: string = target.value;
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (!typeCol.required && Base.isNullOrEmpty(strValue)) {
            newValue.valueStr = "";
            newValue.valueNbr = null;
            this.props.onChange(newValue);
            return;
        }
        newValue.valueNbr = !Base.isNullOrEmpty(strValue) ? Base.strToInteger(strValue, typeCol.minimum, typeCol.maximum) : 0;
        newValue.valueStr = TaskDataRowCol.getTaskDataRowColUiValue(typeCol, newValue.valueStr, newValue.valueNbr);
        props.onChange(newValue);
    };

    render() {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const dataCol = props.taskDataRowCol;
        return (
            <FormField title={getFormFieldTitle(typeCol, props.showFieldName)} titleColor={getFormFieldTitleColor(props.showFieldName, props.showFieldNameColor)} required={typeCol.required && !props.isReadOnly} margin={FormFieldMargin}>
                {props.isReadOnly &&
                    <Typography>{dataCol?.valueStr}</Typography>
                }
                {!props.isReadOnly &&
                    <DisabledInputClickEnabler
                        input={<TextField
                            name={typeCol.field}
                            title={typeCol.title}
                            required={typeCol.required}
                            disabled={props.colIsReadOnly}
                            value={dataCol?.valueStr || ""}
                            InputProps={{
                                // inputProps: {
                                //     min: typeCol.minimum ? typeCol.minimum : null,
                                //     max: typeCol.maximum ? typeCol.maximum : null,
                                // },
                                //inputComponent: IntegerMaskInput as any,
                                endAdornment: typeCol.unitTitle ? <InputAdornment position="end">{typeCol.unitTitle}</InputAdornment> : undefined
                            }}
                            inputProps={{ maxLength: typeCol.maxLength > 0 ? typeCol.maxLength : null }}
                            placeholder={typeCol.placeholder ? typeCol.placeholder : null}
                            autoComplete="off"
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                            size="small"
                            fullWidth
                        />}
                        disabled={props.colIsReadOnly}
                    />
                }
            </FormField>
        );
    }
}